var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassroomDetailUserFollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C6.49445 2 6.9778 2.14662 7.38893 2.42133C7.80005 2.69603 8.12048 3.08648 8.3097 3.54329C8.49892 4.00011 8.54843 4.50277 8.45196 4.98773C8.3555 5.47268 8.1174 5.91814 7.76777 6.26777C7.41814 6.6174 6.97268 6.8555 6.48773 6.95196C6.00277 7.04843 5.50011 6.99892 5.04329 6.8097C4.58648 6.62048 4.19603 6.30005 3.92133 5.88893C3.64662 5.4778 3.5 4.99445 3.5 4.5C3.5 3.83696 3.76339 3.20107 4.23223 2.73223C4.70108 2.26339 5.33696 2 6 2ZM6 1C5.30777 1 4.63108 1.20527 4.05551 1.58986C3.47993 1.97444 3.03133 2.52107 2.76642 3.16061C2.50152 3.80015 2.4322 4.50388 2.56725 5.18282C2.7023 5.86175 3.03564 6.48539 3.52513 6.97487C4.01461 7.46436 4.63825 7.7977 5.31719 7.93275C5.99612 8.0678 6.69985 7.99848 7.33939 7.73358C7.97894 7.46867 8.52556 7.02007 8.91015 6.4445C9.29473 5.86892 9.5 5.19223 9.5 4.5C9.5 3.57174 9.13125 2.6815 8.47487 2.02513C7.8185 1.36875 6.92826 1 6 1ZM16 7H14V5H13V7H11V8H13V10H14V8H16V7ZM10 15H11V12.5C11 11.5717 10.6313 10.6815 9.97487 10.0251C9.3185 9.36875 8.42826 9 7.5 9H4.5C3.57174 9 2.6815 9.36875 2.02513 10.0251C1.36875 10.6815 1 11.5717 1 12.5V15H2V12.5C2 11.837 2.26339 11.2011 2.73223 10.7322C3.20107 10.2634 3.83696 10 4.5 10H7.5C8.16304 10 8.79893 10.2634 9.26777 10.7322C9.73661 11.2011 10 11.837 10 12.5V15Z",
    fill: "#171719"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroomDetailUserFollow);
export default __webpack_public_path__ + "static/media/ClassroomDetail-user_follow.1828ff65d23e5d42284f6fdae43b6de3.svg";
export { ForwardRef as ReactComponent };